import { ExternalModule } from './external/external.module';
import { SharedModule } from '../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerComponent } from './container.component';
import { ContainerRoutingModule } from './container-routing.module';
import { InternalModule } from './internal/internal.module';

@NgModule({
  declarations: [ContainerComponent],
  imports: [
    CommonModule,
    SharedModule,
    // ContainerRoutingModule,
    InternalModule,
    ExternalModule
  ]
})
export class ContainerModule { }
